// Maps a language/subject title to an ISO country code for react-world-flags.
// Centralised so every list view shows the same flag for a given language.
export const getFlagCode = (languageTitle) => {
  switch (languageTitle) {
    case "English":
      return "GB"; // UK flag for English
    case "Swedish":
      return "SE";
    case "Italian":
      return "IT";
    case "French":
      return "FR";
    case "Spanish":
      return "ES";
    case "German":
      return "DE";
    case "Portuguese":
      return "PT";
    case "Dutch":
      return "NL";
    default:
      return "GB"; // Fallback to UK flag for unrecognised languages
  }
};
